"use client";

import * as React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
export default function NewsletterSignup() {
  return <section data-section-id="124967" id="blijf-verbonden" className="text-foreground py-16 px-4 border-t border-border/10 !bg-[hsl(218,50%,9%)] md:py-24">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <h2 className="text-3xl font-bold tracking-tight mb-4 font-default !text-[hsl(250,75%,67%)] md:text-4xl">
            Blijf Verbonden
          </h2>
          <p className="text-lg !text-[hsl(215,16%,60%)]">Ontvang inzichten en strategieën om jouw online groei en zichtbaarheid te versterken.</p>
        </div>

        <div className="lg:col-span-7">
          <FormProvider formKey="stay_connected_form_blog" formId="stay_connected_form_blog" sectionName="NewsletterSignup" defaultValues={{
          first_name: "",
          email: "",
          agree_terms: false
        }} validationRules={{
          email: {
            required: true,
            pattern: "email"
          },
          agree_terms: {
            required: true
          }
        }} submitText="Inschrijven" successMessage="Bedankt voor je aanmelding! Je ontvangt binnenkort onze eerste inzichten.">
            <NewsletterForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-accent/10 border border-accent/20 rounded-xl text-center animate-in fade-in duration-500">
        <p className="font-medium text-lg font-default text-[#8896A9]">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <FormField control={control} name="first_name" render={({
        field
      }) => <FormItem className="flex-1">
              <FormLabel className="sr-only text-[#8896A9]">Voornaam</FormLabel>
              <FormControl>
                <Input placeholder="Voornaam (Optioneel)" {...field} className="h-12 bg-secondary/30 border-border/50 focus-visible:ring-accent text-base rounded-lg text-[#8896A9] placeholder:text-[#8896A9]" />
              </FormControl>
              <FormMessage className="text-[#8896A9]" />
            </FormItem>} />
        <FormField control={control} name="email" rules={{
        required: "E-mailadres is verplicht",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Voer een geldig e-mailadres in"
        }
      }} render={({
        field
      }) => <FormItem className="flex-[2]">
              <FormLabel className="sr-only text-[#8896A9]">E-mailadres</FormLabel>
              <FormControl>
                <Input type="email" placeholder="je@email.nl" {...field} className="h-12 bg-secondary/30 border-border/50 focus-visible:ring-accent text-base rounded-lg text-[#8896A9] placeholder:text-[#8896A9]" />
              </FormControl>
              <FormMessage className="text-[#8896A9]" />
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} size="lg" className="h-12 w-full sm:w-auto bg-[#836eea] text-[#090e16] hover:bg-[#836eea]/90 font-semibold px-8 rounded-lg transition-all duration-300">
          {isSubmitting ? <Loader className="animate-spin size-5 mr-2" /> : null}
          Inschrijven
        </Button>
      </div>

      <FormField control={control} name="agree_terms" rules={{
      required: "Je moet akkoord gaan om verder te kunnen"
    }} render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <input type="checkbox" className="mt-1 size-4 shrink-0 rounded border-border/50 bg-secondary/30 text-accent focus:ring-accent focus:ring-offset-background accent-accent" checked={field.value} onChange={field.onChange} />
            </FormControl>
            <div className="space-y-1.5 leading-none">
              <FormLabel className="text-sm font-normal cursor-pointer text-[#8896A9]">
                Ik ga akkoord met het ontvangen van updates en tips van Connected Online
              </FormLabel>
              <FormDescription className="text-xs text-[#8896A9]">
                Je kunt je op elk moment afmelden. Wij gaan zorgvuldig om met je data.
              </FormDescription>
              <FormMessage className="text-[#8896A9]" />
            </div>
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-sm font-medium text-[#8896A9]">{submitError}</p>
        </div>}
    </Form>;
}